export default __webpack_public_path__ + "static/media/DoorOpenings.3087fa80.svg";